import React from 'react';

import { Box, Group } from '@mantine/core';
import { useWindowScroll } from '@mantine/hooks';

import { utils } from "../utils/globalVariables";

import LoaderLine from "../components/general/LoaderLine";

const WrapperUtils = ({ children, stateDataLoading }) => {

    const [scroll] = useWindowScroll();

    let headerNavComponentHeight = React.useRef(0);
    let tabNavBarHeight = React.useRef(0);

    React.useEffect(() => {
        const headerNavComponent = document.querySelector(".headerNavComponent");
        const tabNavBar = document.querySelector(".tabNavBar");

        headerNavComponentHeight.current = headerNavComponent ? headerNavComponent.offsetHeight : 0;
        tabNavBarHeight.current = tabNavBar ? tabNavBar.offsetHeight : 0;
    }, [scroll])

    return (
        <Box
            sx={(tema) => ({
                position: 'sticky',
                top: headerNavComponentHeight.current + tabNavBarHeight.current,
                zIndex: 1,

                // '& .headerNavComponent': {
                //     transition: '100ms linear',

                //     backgroundColor: tema.colorScheme === 'light' ? (scroll.y > utils.shrinkWhenScrollYAt ? '#fff' : '#fff') : (scroll.y > utils.shrinkWhenScrollYAt ? tema.colors.dark[7] : tema.colors.dark[7]),

                //     borderBottomWidth: '1px',
                //     borderBottomStyle: 'solid',
                //     borderBottomColor: tema.colorScheme === 'light' ? (scroll.y > utils.shrinkWhenScrollYAt ? tema.colors.gray[2] : tema.colors.gray[2]) : (scroll.y > utils.shrinkWhenScrollYAt ? tema.colors.dark[6] : tema.colors.dark[6]),
                // },

                '& .utilsNavComponent': {
                    transition: '100ms linear',

                    backgroundColor: tema.colorScheme === 'light' ? (scroll.y > utils.shrinkWhenScrollYAt ? tema.colors.gray[0] : tema.colors.gray[0]) : (scroll.y > utils.shrinkWhenScrollYAt ? tema.colors.dark[8] : tema.colors.dark[8]),

                    '& .utilsNavComponentInner': {
                        borderBottomWidth: '1px',
                        borderBottomStyle: 'solid',
                        borderBottomColor: tema.colorScheme === 'light' ? (scroll.y > utils.shrinkWhenScrollYAt ? tema.colors.gray[2] : tema.colors.gray[2]) : (scroll.y > utils.shrinkWhenScrollYAt ? tema.colors.dark[6] : tema.colors.dark[7]),
                    }
                },
            })}
        >
            <Box
                className='utilsNavComponent'
                px='md'
            >
                <Group
                    className='utilsNavComponentInner'
                    spacing='xs'
                    position='apart'
                    py='sm'
                >
                    {children}
                </Group>

                {stateDataLoading &&
                    <Box
                        sx={{
                            position: 'relative',
                        }}
                    >
                        <LoaderLine
                            statePosition='absolute'
                            stateIsTop={false}
                        />
                    </Box>
                }
            </Box>
        </Box>
    )
}

export default WrapperUtils;